import React from 'react';
import {makeStyles, Modal, styled} from "@material-ui/core";
import useRoomState from "./twilio/hooks/useRoomState/useRoomState";
import {VideoProvider} from "./twilio/components/VideoProvider";
import ErrorDialog from "./twilio/components/ErrorDialog/ErrorDialog";
import Room from "./twilio/components/Room/Room";
import LocalVideoPreview from "./twilio/components/LocalVideoPreview/LocalVideoPreview";
import Controls from "./twilio/components/Controls/Controls";
import {useAppState} from "./twilio/state";
import generateConnectionOptions from './twilio/utils/generateConnectionOptions/generateConnectionOptions';
import useVideoContext from "./twilio/hooks/useVideoContext/useVideoContext";

function calcWidth() {
    return 1280//window.innerWidth >= 1350 ? 1280 : 896
}

function calcHeight() {
    return 720//window.innerHeight >= 800 ? 720 : 504
}

function getModalStyle() {
    let w = calcWidth();
    let h = calcHeight();
    const left = w / 2 + 38;

    return {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        top: `20px`,
        left: `50%`,
        transform: `translate(-${left}px, 0px)`,
        width: `${w}px`,
        height: `${h}px`,
    };
}

const Main = styled('main')({
    overflow: 'hidden',
});

function RoomSwitch(props) {
    const {token} = useAppState()
    const roomState = useRoomState();
    const {connect} = useVideoContext();
    const callConnect = () => connect(token, props.videoChatRoomName)

    return <Main>
        {roomState === 'disconnected' ? <LocalVideoPreview/> : <Room/>}
        <Controls hideVideoChat={props.hideVideoChat} callConnect={callConnect}/>
    </Main>
}

function VideoChatModal(props) {
    const useStyles = makeStyles((theme) => ({
        paper: {
            position: 'absolute',
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
        },
    }));
    const classes = useStyles();
    const {error, setError, settings} = useAppState();
    const connectionOptions = generateConnectionOptions(settings);

    return (
        <div>
            <Modal
                open={props.videoChatRoomName !== null}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <div style={getModalStyle()} className={classes.paper}>
                    <h2 id="simple-modal-title">{props.videoChatRoomName}</h2>
                    <VideoProvider options={connectionOptions} onError={setError}>
                        <ErrorDialog dismissError={() => setError(null)} error={error}/>
                        <RoomSwitch videoChatRoomName={props.videoChatRoomName} hideVideoChat={props.hideVideoChat}/>
                    </VideoProvider>

                    {/*<Jitsi
                        onAPILoad={videoClosingTrigger}
                        containerStyle={{width: `${calcWidth()}px`, height: `${calcHeight()}px`}}
                        roomName={props.videoChatRoomName} displayName={props.videoChatRoomName}/>*/}
                </div>
            </Modal>
        </div>
    );
}

export default VideoChatModal
  
  